<div *ngIf="licensePageWIPMsg" class="fulfillmentLanding xs-mb-20">
  <div class="status-bar">
    {{licensePageWIPMsg}}
  </div>
</div>
<div class="licenseLanding licensePagecss">
  <div class="fulfillmentLanding cpp-wrapper" style="width: 100%; margin:0;">
    <div class="cppLandingPage margin-0">
      <div class="licenseTopSec">
        <div class="alignTopSec">
          <div class="row">
            <div class="col-md-12 col-lg-12 margin-l0 cppTopSec">
              <h3>
                Grower Licenses
              </h3>
            </div>
          </div>
          <div class="form-sec">
            <div class="row margin-t10 margin-b10 margin-r0">
              <div class="col-sm-7 col-md-8 col-lg-9 col-xl-10 smallPadRgt0 margin-l0">
                <div class="row search-box-outer">
                  <div class="col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight">

                    <div class="category-dropdown material-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="selectedValue"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindValue="value"
                                 labelForId="name"
                                 [searchable]="false"
                                 (change)="retainFilter(null, ' ')">
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-8 col-lg-9 padding-l4 padding-r0 ">
                    <div class="material-select reports-search-filter">

                      <ng-select #TraitManufacturer name="ddlVendorSearch" *ngIf="selectedValue === 'Trait Manufacturer'"
                                 [items]="traitManufacturerList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.TraitManufacturerList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFn"
                                 (change)="retainFilter(TraitManufacturer,'Trait Manufacturer')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <div *ngIf="selectedValue=='License Number'">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.LicenseNumber"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-select #LicenseStatus name="ddlLicenseStatus" *ngIf="selectedValue === 'License Status'"
                                 [items]="licenseStatusList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.LicenseStatusList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFn"
                                 (change)="retainFilter(LicenseStatus,'License Status')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <div *ngIf="selectedValue=='Account City'">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.AccountCity"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-select #AccountState name="ddlAccountState" *ngIf="selectedValue === 'Account State'"
                                 [items]="accountStateList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.AccountStateList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFn"
                                 (change)="retainFilter(AccountState,'Account State')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <ng-select #GrowerState name="ddlGrowerState" *ngIf="selectedValue === 'Grower State'"
                                 [items]="growerStateList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.GrowerStateList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFn"
                                 (change)="retainFilter(GrowerState,'Grower State')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <div *ngIf="selectedValue=='Grower Name' && isEvolveAccountRestriction == false">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.TxtGrowerName"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-select #GrowerName name="ddlGrowerName" *ngIf="selectedValue === 'Grower Name' && isEvolveAccountRestriction == true"
                                 [items]="growerNameList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.GrowerNameList"
                                 [virtualScroll]="true"
                                 bindLabel="businessName"
                                 bindValue="businessName"
                                 [closeOnSelect]="true"
                                 [searchFn]="growerSearchFn"
                                 (change)="retainFilter(GrowerName,'Grower Name')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <h4 class="name greenColor" [ngOptionHighlight]="search">
                                  {{item.businessName}}
                                </h4>
                                <p class="address" [ngOptionHighlight]="search">
                                  {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zip}}
                                </p>
                                <p class="phoneNo" [ngOptionHighlight]="search">
                                  {{item.primaryPhoneNumber}}
                                </p>
                                <p class="grower-nos">
                                  <span class="grower-gln" [ngOptionHighlight]="search">
                                    Grower GMK: {{item.gmk}}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <ng-select #District *ngIf="selectedValue === impDisplayName"
                                 [items]="districtMasterList"
                                 placeholder="Search..."
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 class="custom-select-grower"
                                 [(ngModel)]="productFilters.DistrictList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFun"
                                 (change)="retainFilter(District,'District')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <ng-select #SEL *ngIf="selectedValue === 'SEL'"
                                 [items]="selList"
                                 placeholder="Search..."
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 class="custom-select-grower"
                                 [(ngModel)]="productFilters.SelNameList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFun"
                                 (change)="retainFilter(SEL,'SEL')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>

                      <div *ngIf="selectedValue=='Grower City'">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.GrowerCity"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="selectedValue=='Grower Order Number'">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.GrowerOrderNumber"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="selectedValue=='Parent Account Number'">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.ParentAccount"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-select #AccountNo *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == true"
                                 [items]="accountsList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.AccountNo"
                                 [virtualScroll]="true"
                                 bindLabel="accountNameCityState"
                                 bindValue="accountNumber"
                                 [closeOnSelect]="true"
                                 [searchFn]="accountSearchFn"
                                 (change)="retainFilter(AccountNo,'AccountNo')">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row" *ngIf="item.accountNumber!=-1">
                              <div class="col-md-8">
                                <h4 class="name greenColor" [ngOptionHighlight]="search">
                                  {{item.accountName}}
                                </h4>
                                <p class="address" [ngOptionHighlight]="search">
                                  {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                                </p>
                                <p class="phoneNo" [ngOptionHighlight]="search">
                                  {{item.primaryPhoneNumber}}
                                </p>
                                <p class="grower-nos">
                                  <span class="grower-gln" [ngOptionHighlight]="search">
                                    Account #: {{item.accountNumber}}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="row" *ngIf="item.accountNumber==-1">
                              <div class="col-md-8">
                                <h4 class="name" [ngOptionHighlight]="search">
                                  {{item.accountName}}
                                </h4>
                                <p class="grower-nos">
                                  <span class="grower-gln" [ngOptionHighlight]="search">
                                    Account #: {{item.accountNumber}}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>
                      <div #productSearch *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.TxtAccountNo"
                                     placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div #productSearch *ngIf="selectedValue === 'Account Name'  && isEvolveAccountRestriction == false">
                        <div class="search-box-outer">
                          <div class="search-box wide100">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input (keyup.enter)="retainFilter(null, ' ');" [(ngModel)]="productFilters.AccountName"
                                     placeholder="Search..." type="text">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 col-md-4 col-lg-3 col-xl-2 search-btn-outer text-right padding-l20 padding-r0">
                <div class="row">
                  <div class="col-sm-6 padding-r15">
                    <div class="search-btn">
                      <button mat-raised-button class="btns" (click)="retainFilter(null, ' ');getLicensingData();" color="primary">Search</button>
                    </div>
                  </div>
                  <div class="col-sm-6 padding-r0">
                    <div class="search-btn">
                      <button mat-raised-button class="btns" (click)="retainFilter(null, ' ');getLicensingReport();" color="primary">Email Report</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-10 padding-r0 margin-t-5">
                <div class="chips-sec">
                  <div class="row selected-chip">
                    <div class="col-sm-9 col-md-6 padding-l0">
                      <div>
                        <mat-chip-set>
                          <mat-chip selected *ngFor="let filterValue of filterValueList">
                            {{filterValue}}
                            <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                              <i class="fas fa-times text-right"></i>
                            </a>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>
                    <div class="col-sm-3 col-md-3 text-center">
                      <mat-checkbox class="custom-checkbox" [(ngModel)]="showAllLicences" ng-checked="showAllLicences" (change)="changeShowAllLicences($event)">Show All Licenses</mat-checkbox>
                    </div>
                    <div class="col-sm-3 col-md-3 text-right padding-r30" *ngIf="filterValueList.length > 0">
                      <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="row detailedInfo" *ngIf="gmkList !== undefined && gmkList.length > 0">
                  <div class="col-md-9 padding-r0">
                    <div class="row">
                      <div class="col-sm-4 col-md-3">
                        <p>NUMBER OF GROWERS: {{growerCount}}</p>
                      </div>
                      <div class="col-sm-2 col-md-2">
                        <p>UNLICENSED: {{unlicensedCount}}</p>
                      </div>
                      <div class="col-sm-6 col-md-7">
                        <p>UNAUTHORIZED: {{unauthorizedCount}}</p>
                      </div>
                    </div>
                    <div class="row margin-t-15 ">
                      <div class="col-sm-2 col-md-1 padding-r0 detailedValue"><p>UNLICENSED: </p></div>
                      <ng-template ngFor let-vendor [ngForOf]="vendorMasterList">
                        <div class=" col-sm-2 col-md-2 detailedValue">
                          <p>{{vendor.value}}: {{getVendorCount(vendor)}}</p>
                        </div>
                      </ng-template>
                    </div>
                  </div>

                  <div class="col-md-3 margin-l-20 padding-l0">
                    <div class="margin-t20"><a href="https://www.agcelerate.com/" target="_blank"> Visit AgCelerate<i class="fas fa-external-link-alt linkColor"></i></a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="licenseBottomSec">
        <div class="search-results">
          <ng-template ngFor let-item [ngForOf]="gmkList" let-i="index">
            <div class="searchRow" *ngIf="getGrowerList(item); let grower">

              <div class="col-sm-4 col-md-4 col-lg-3 searchColumn">
                <div class="card">
                  <div class=" row tableHeader">
                    <div class="col-sm-9 col-md-10 col-lg-10">
                      <div class="businessName">
                        <p class="dataWrap growerName" data-toggle="tooltip" data-placement="top" title="{{grower.growerName}}">
                          {{grower.growerName}}
                        </p>
                        <p class="dataWrap margin-t-15" data-toggle="tooltip" data-placement="top" title="{{grower.growerBusinessName}}">
                          {{grower.growerBusinessName}}
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-3 col-md-2 col-lg-2 tab-bar padding-l0 margin-t25 text-right">
                      <ul>
                        <li *ngIf="!hasOrderByGmk(grower.gmk) && !readOnlyAccess" data-toggle="tooltip" data-placement="top" title="{{licensePageWIPMsg}}"
                            (click)="addUpdateLicense(grower)"><i class="far fa-edit"></i></li>
                        <li class="backButton" *ngIf="hasOrderByGmk(grower.gmk)" (click)="backToList()"><i class="fa fa-arrow-left"></i></li>
                      </ul>
                    </div>
                    <div class="col-md-10 addressFont padding-r0 margin-t-15">
                      <p class="dataWrap" data-toggle="tooltip" data-placement="top" title="{{grower.growerAddress1}}">
                        {{grower.growerAddress1}}
                      </p>
                      <p class="margin-t-20 dataWrap" data-toggle="tooltip" data-placement="top" title="{{grower.growerCity}}, {{grower.growerState}} - {{grower.growerZipCode}}">
                        {{grower.growerCity}}, {{grower.growerState}} - {{grower.growerZipCode}}
                      </p>
                    </div>
                  </div>
                  <div class="growerLicenseDetails">
                    <div class="row tableRow1" *ngIf="!hasOrderByGmk(grower.gmk)">
                      <div class="col-sm-5 col-md-3 col-lg-3 padding-r0">REQUIRED: </div>
                      <div class="col-sm-2 col-md-1 col-lg-1 padding-l0"><button class="roundedBtn"> {{getRequired(item)}}</button></div>
                      <div class="col-sm-5 col-md-8 col-lg-8 text-right">LICENSE</div>
                    </div>

                    <ng-template *ngIf="!hasOrderByGmk(grower.gmk)" ngFor let-vendor [ngForOf]="vendorMasterList" let-counter="index+2">

                      <div class="row licenseTile tableRow{{counter}}" data-toggle="tooltip" data-placement="top"
                           *ngIf="getGrowerLicenseDetail(item,vendor.id) || !getGrowerLicenseDetail(item,vendor.id); let record"
                           (click)="record?.isActive && getLicenseOrderDetail(vendor, grower, getGrowerLicenseDetail(item,vendor.id));grower.counter=counter;">
                        <div class="col-md-1 padding-r0 licenseStatus" title="{{getLicenseStatus(record?.licenseStatus)}}" *ngIf="record?.isActive && record?.licenseStatus==='P'"><span class="dot yellowDot"></span></div>
                        <div class="col-md-1 padding-r0 licenseStatus" title="{{getLicenseStatus(record?.licenseStatus)}}" *ngIf="record?.isActive && (record?.licenseStatus==='U' || record?.licenseStatus==='N')"><span class="dot redDot"></span></div>
                        <div class="col-md-1 padding-r0 licenseStatus" title="{{getLicenseStatus(record?.licenseStatus)}}" *ngIf="record?.isActive && record?.licenseStatus==='D'"><span class="dot blackDot"></span></div>
                        <div class="col-md-1 padding-r0 licenseStatus" title="{{getLicenseStatus(record?.licenseStatus)}}" *ngIf="record?.isActive && record?.licenseStatus==='L'"><span class="dot greenDot"></span></div>
                        <div class="col-md-1 padding-r0 licenseStatus" *ngIf="!record?.isActive || !record?.licenseStatus"></div>
                        <div class="col-md-5 padding-r0 licenseName dataWrap" [ngClass]="{'disabled': !record?.licenseStatus || !record?.isActive}" data-toggle="tooltip" data-placement="top" title="{{vendor.value}}">{{vendor.value}}</div>
                        <div class="col-md-6 padding-l0 text-right dataWrap" [ngClass]="{'disabled': !record?.licenseStatus || !record?.isActive}" data-toggle="tooltip" data-placement="top" title="{{record?.licenseNumber}}">{{record?.licenseNumber}}</div>
                      </div>
                    </ng-template>

                    <div class="row licenseTile tableRow{{grower.counter}}" *ngIf="hasOrderByGmk(grower.gmk)">
                      <div class="col-md-1 padding-r0" title="Pending" *ngIf="selectedGMK?.licenseStatus==='P'"><span class="dot yellowDot"></span></div>
                      <div class="col-md-1 padding-r0" title="Unlicensed" *ngIf="selectedGMK?.licenseStatus==='U' || selectedGMK?.licenseStatus==='D'|| selectedGMK?.licenseStatus==='N'"><span class="dot redDot"></span></div>
                      <div class="col-md-1 padding-r0" title="Licensed" *ngIf="selectedGMK?.licenseStatus==='L'"><span class="dot greenDot"></span></div>
                      <div class="col-md-1 padding-r0" *ngIf="!selectedGMK?.licenseStatus"></div>
                      <div class="col-md-5 padding-r0 dataWrap" data-toggle="tooltip" data-placement="top" title="{{selectedGMK.vendor}}">{{selectedGMK.vendor}}</div>
                      <div class="col-md-6 padding-l0 text-right dataWrap" data-toggle="tooltip" data-placement="top" title="{{selectedGMK?.licenseNumber}}">{{selectedGMK?.licenseNumber}}</div>
                    </div>

                    <div class="row tableRow1" *ngIf="hasOrderByGmk(grower.gmk)">
                      <div class="col-md-6">ORDER </div>
                    </div>
                    <div class="orderDetails detailRow{{grower.counter}} padding-0" *ngIf="hasOrderByGmk(grower.gmk)">
                      <div class="row padding-l15 licenseTile tableRow{{grower.counter}}" *ngFor="let order of orderDetail">
                        <div class="col-md-12"
                             [ngClass]="{'text-decoration-underline':!order?.isPartnerOrder,'defaultCursor':order?.isPartnerOrder}"
                             (click)="redirectToOrder(order)">
                          <span>{{order.orderNumber}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
